export default __webpack_public_path__ + "locales/si/DataReassignmentDialog.json?hash=d3850cc463c0528df49795ce30cc48a1";